'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupDebug = setupDebug;

var _immutable = require('immutable');

window.__HUBSPOT_CONVERSATIONS__ = {};

function setupDebug(store) {
  window.__HUBSPOT_CONVERSATIONS__.downloadDebugData = function () {
    var json = JSON.stringify((0, _immutable.fromJS)(store.getState()).toJS());
    var data = 'text/json;charset=utf-8,' + encodeURIComponent(json);

    var a = document.createElement('a');
    a.href = 'data:' + data;
    a.download = 'conversations_' + new Date().toISOString() + '.json';
    a.click();
  };
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-lib/static-1.28/js/debug.js
// module id = 445
// module chunks = 0